import { ajaxRefreshToken } from "./authenticationService";

const isBrowser = typeof window !== "undefined"

const inMemoryJWTManager = () => {
    let inMemoryJWT: any = null;
    let refreshTimeoutId: any;
    const storageKey = 'logout';


    if (isBrowser) {
        window.addEventListener('storage', event => {
            if (event.key === storageKey) {
                inMemoryJWT = null;
            }
        });
    }



    const refreshToken = (expiration: any) => {
        const delay = new Date(expiration).getTime() - new Date().getTime();
        // Fire five seconds before JWT expires
        const timeoutTrigger = delay - 5000;

        if (isBrowser) {
            refreshTimeoutId = window.setTimeout(() => {
                ajaxRefreshToken()
                    .then((res: any) => {
                        const { token, tokenExpiration } = res;
                        setToken(token, tokenExpiration);
                    }).catch(console.error);
            }, timeoutTrigger);
        }
    };

    const abortRefreshToken = () => {

        if (isBrowser) {
            if (refreshTimeoutId) {
                window.clearTimeout(refreshTimeoutId);
            }
        }
    };

    const getToken = () => inMemoryJWT;

    const setToken = (token: any, tokenExpiration: any) => {
        inMemoryJWT = token;
        refreshToken(tokenExpiration);
        return true;
    };

    const deleteToken = () => {
        inMemoryJWT = null;
        abortRefreshToken();
        if (isBrowser) {
            window.localStorage.setItem(storageKey, Date.now().toString());
        }
        return true;
    };

    return {
        getToken,
        setToken,
        deleteToken
    };
};

export default inMemoryJWTManager();